import { useParams, useLocation } from "react-router-dom";
import NotFound from "../Pages/NotFound";
import { TEST_PAYMENT_PATH_SEGMENT } from "../constants";

const VALID_LANGUAGES = ["az", "ru", "en"];
const VALID_ROUTES = [
  "product",
  "productnew",
  "aylik-odenis",
  "business",
  "menu-page",
  "searchResult",
  "credit-payment",
  "comparison",
  "contact",
  "qanunvericilik",
  "mxfilik-siyaseti",
  "saytdan-istifade-sertleri",
  "cart",
  "sign_in",
  "sign_up",
  "profile",
  "Page",
  "Search",
  TEST_PAYMENT_PATH_SEGMENT,
];

const RouteValidator = ({ children, isHomeRoute = false }) => {
  const { lang } = useParams();
  const location = useLocation();
  const pathname = location.pathname;
  const pathSegments = pathname.split("/").filter(Boolean);

  // Check if language is valid (if lang param exists)
  if (lang && !VALID_LANGUAGES.includes(lang)) {
    return <NotFound />;
  }

  // For home route (/:lang), check if path is exactly /lang or /lang/
  if (isHomeRoute && lang) {
    // Strict check: pathname must be exactly /lang or /lang/
    const normalizedPath = pathname.replace(/\/$/, '');
    const expectedPath = `/${lang}`;
    
    // If path doesn't match exactly, show 404
    if (normalizedPath !== expectedPath) {
      return <NotFound />;
    }
    
    // Also check segments - must be exactly one segment (the language)
    if (pathSegments.length !== 1 || pathSegments[0] !== lang) {
      return <NotFound />;
    }
    
    return children;
  }

  // If we have a language in the path, check if the route after it is valid
  if (lang && VALID_LANGUAGES.includes(lang) && pathSegments.length > 1) {
    const routeAfterLang = pathSegments[1];
    
    // Check if it's a valid route
    if (routeAfterLang && !VALID_ROUTES.includes(routeAfterLang)) {
      return <NotFound />;
    }
  }

  // Check for invalid root-level paths (not starting with valid language)
  if (pathSegments.length > 0 && !VALID_LANGUAGES.includes(pathSegments[0]) && pathSegments[0] !== "payment-result") {
    return <NotFound />;
  }

  return children;
};

export default RouteValidator;

